import { faq } from '../content/faq';

export const Faq = () => (
  <section className="section faq" id="faq" aria-labelledby="faq-title">
    <div className="container-narrow">
      <p className="eyebrow">Honest answers</p>
      <h2 id="faq-title" className="h-section">
        Frequently asked, before you ask.
      </h2>

      <div className="faq__list">
        {faq.map((item) => (
          <details key={item.q} className="faq__item">
            <summary className="faq__summary">
              <span>{item.q}</span>
              <span className="faq__plus" aria-hidden="true">
                +
              </span>
            </summary>
            <p className="faq__answer">{item.a}</p>
          </details>
        ))}
      </div>

      <p className="faq__cta">
        Still have questions? Join first — we&apos;ll answer in beta.{' '}
        <a href="/#waitlist">Save your seat →</a>
      </p>
    </div>
  </section>
);
